
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "JulianGradingMethodForVaginalCurvatureAndProtrusion",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/JulianGradingMethodForVaginalCurvatureAndProtrusion.vue